import { TrackJS } from 'trackjs';
import { AppConfig } from '../app/appState.interface';
import store from './store';

export default async (): Promise<AppConfig> => {
    async function getAppConfig() {
        return await (await fetch(`${process.env.PUBLIC_URL}/config/appConfig.json`)).json();
    }

    if (store && Object.keys(store.getState().app.appConfig).length > 0) {
        return store.getState().app.appConfig;
    }

    const appConfig = await getAppConfig();
    if (appConfig.TRACK_JS_TOKEN) {
        TrackJS.install({
            application: appConfig.TRACK_JS_APPLICATION,
            token: appConfig.TRACK_JS_TOKEN,
        });
    }

    return appConfig;
};
